/** Re-encodes an image file through a canvas, e.g. to shrink phone photos before upload */
type CompressOptions = { quality?: number, type?: string }

export const compressImage = async (file: File, { quality = 1, type = file.type }: CompressOptions) => {
  const imageBitmap = await createImageBitmap(file)
  const canvas = document.createElement('canvas')
  canvas.width = imageBitmap.width
  canvas.height = imageBitmap.height
  canvas.getContext('2d')?.drawImage(imageBitmap, 0, 0)
  const blob = await new Promise<Blob>((resolve, reject) => {
    canvas.toBlob((result) => (result ? resolve(result) : reject(new Error('Не удалось обработать фото'))), type, quality)
  })
  return new File([blob], file.name, { type: blob.type })
}
